/* Slept-On Cinema: consent-aware, non-PII engagement measurement. */
(function () {
  'use strict';
  if (window.__socMeasurement) return;
  window.__socMeasurement = true;
  var ID = 'G-3MVVZ0EMBB';
  var params = new URLSearchParams(location.search);
  var debug = params.get('soc_debug') === '1';
  var qa = params.get('soc_qa') === '1' || (window.Shopify && (Shopify.designMode || (Shopify.theme && Shopify.theme.role !== 'main')) && !debug);
  var allowed = false, started = false;
  var page = location.origin + location.pathname;
  var referrer = '';
  try { var ref = new URL(document.referrer); referrer = ref.origin + ref.pathname; } catch (_) {}
  window.dataLayer = window.dataLayer || [];
  function command() { window.dataLayer.push(arguments); }
  command('consent', 'default', {analytics_storage:'denied', ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied'});
  // Existing movie/drink widgets call gtag. Drop events until processing is allowed.
  window.gtag = function (action, name, details) {
    if (action !== 'event' || !allowed || qa) return;
    var clean = {page_location:page, page_referrer:referrer};
    ['movie','kind','heat','company','episode','film','drink','destination','surface','method'].forEach(function (key) {
      if (details && details[key] !== undefined) clean[key] = String(details[key]).slice(0,100);
    });
    if (debug) { clean.debug_mode = true; clean.traffic_type = 'internal'; }
    command('event', name, clean);
  };
  function update() {
    var privacy = window.Shopify && Shopify.customerPrivacy;
    allowed = !!(privacy && privacy.analyticsProcessingAllowed());
    if (qa) allowed = false;
    if (!started && allowed) {
      started = true;
      command('consent','update',{analytics_storage:'granted'});
      command('js', new Date());
      var config = {send_page_view:false, page_location:page, page_referrer:referrer,
        allow_google_signals:false, allow_ad_personalization_signals:false};
      if (debug) { config.debug_mode=true; config.traffic_type='internal'; }
      command('config',ID,config);
      window.gtag('event','page_view',{});
      var script = document.createElement('script');
      script.async=true; script.src='https://www.googletagmanager.com/gtag/js?id='+ID;
      document.head.appendChild(script);
      document.documentElement.dataset.socAnalytics = debug ? 'debug' : 'active';
    } else if (started) {
      command('consent','update',{analytics_storage:allowed?'granted':'denied'});
      document.documentElement.dataset.socAnalytics = allowed ? (debug?'debug':'active') : 'paused';
    } else { document.documentElement.dataset.socAnalytics = qa ? 'qa-off' : 'waiting-consent'; }
  }
  function ready() {
    document.addEventListener('visitorConsentCollected',update);
    if (window.Shopify && Shopify.customerPrivacy) update();
    else if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error) update();});
    }
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',ready,{once:true});
  else ready();
  document.addEventListener('click',function(event){
    var el=event.target.closest('a,button'); if(!el) return;
    var surface=el.closest('.soc-machine')?'movie_matcher':el.closest('.soc-bar')?'drink_menu':'site';
    if(el.hasAttribute('data-share')) { window.gtag('event','share_intent',{surface:surface}); return; }
    if(el.hasAttribute('data-soc-player-trigger') || el.hasAttribute('data-soc-modal-open')) { window.gtag('event','episode_player_open',{surface:'home',episode:80}); return; }
    if(el.tagName!=='A') return;
    var url; try {url=new URL(el.href,location.origin);} catch(_){return;}
    var destination=url.hostname+url.pathname;
    if(/(^|\.)(acast\.com|spotify\.com|apple\.com)$/.test(url.hostname))
      window.gtag('event','listen_click',{destination:destination,surface:surface});
    else if(url.hostname==='sleptons-newsletter.beehiiv.com' && url.pathname.indexOf('/subscribe')===0)
      window.gtag('event','club_signup_click',{surface:surface});
    else if(url.origin===location.origin && url.pathname==='/pages/reappraisal-club')
      window.gtag('event','club_page_click',{surface:surface});
  });
})();

